import { useEffect, Dispatch, SetStateAction } from 'react';
import { User } from '../types';
import { safeApiFetch } from '../utils/apiClient';

export function useAuthSession(
  token: string | null,
  setUser: Dispatch<SetStateAction<User | null>>,
  setView: Dispatch<SetStateAction<'home' | 'blogs' | 'dashboard' | 'exam'>>,
  syncProfile: (authToken: string) => Promise<void>
) {
  useEffect(() => {
    const autoLoginCheck = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const res = await safeApiFetch<User>('/api/auth/me', {
            headers: { 'Authorization': `Bearer ${storedToken}` }
          });
          if (res.ok && res.data) {
            setUser(res.data);
            localStorage.setItem('user', JSON.stringify(res.data));
            if (res.data.role === 'admin') {
              setView('dashboard');
            }
          } else {
            // Check if client session user stored locally on static hosting environments
            const cachedUserStr = localStorage.getItem('user');
            if (cachedUserStr && (res.error?.includes('HTML page') || res.status === 0 || res.status === 404)) {
              try {
                const cachedUser = JSON.parse(cachedUserStr);
                setUser(cachedUser);
                if (cachedUser.role === 'admin') {
                  setView('dashboard');
                }
              } catch (e) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
              }
            } else if (res.status === 401 || res.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
            }
          }
        } catch (err) {
          console.error('Super Admin auto-login verification failed:', err);
        }
      }
    };

    autoLoginCheck();
  }, [setUser, setView]);
}
